<script>
import materialList from './material-list'
import visibilitySingleList from './visibility-single-list'
import visibilityGroupList from './visibility-group-list'
import viewsList from './views-list'
import statesList from './states-list'
import environmenttexturesList from './environmenttextures-list'
import designSummary from './design-summary'
import liquidList from './liquid-list'

export default {
  name: 'list',
  components: {
    materialList,
    visibilitySingleList,
    visibilityGroupList,
    viewsList,
    environmenttexturesList,
    statesList,
    liquidList
  },
  computed: {
    hasMaterials () {
      const state = this.$store.getters['materialList/getState']
      if (state.materials !== undefined) {
        const mtlWithOptions = state.materials.filter(mtl => mtl.options.length > 1)
        return mtlWithOptions.length > 0
      } else {
        return false
      }
    },
    hasLiquid () {
      const state = this.$store.getters['liquid/getState']
      if (state.liquid !== undefined) {
        // const presetWithOptions = state.liquid.filter(lq => lq.liquidpresets.options.length > 1)
        // return presetWithOptions.length > 0
        return state.liquid.length > 0
      } else {
        return false
      }
    },
    hasEnvironmentTextures () {
      const state = this.$store.getters['environmenttexturesList/getState']
      return state.environmenttextures !== undefined && state.environmenttextures.length > 0
    },
    hasViews () {
      const state = this.$store.getters['viewsList/getState']
      return state.views !== undefined && state.views.length > 0
    },
    hasStates () {
      const state = this.$store.getters['statesList/getState']
      return state.states !== undefined && state.states.length > 0
    },
    hasScenes () {
      const state = this.$store.getters['scenes/getState']
      return state.length > 1
    },
    hasOptions () {
      const stateSingle = this.$store.getters['visibilitySingleList/getState']
      const stateGroup = this.$store.getters['visibilityGroupList/getState']
      if (stateSingle.visibilityoptionssingle !== undefined && stateSingle.visibilityoptionssingle.length > 0) {
        return true
      }
      if (stateGroup.visibilityoptionsgroup !== undefined && stateGroup.visibilityoptionsgroup.length > 0) {
        return true
      }
      return false
    }
  },
  data: () => ({
    expandSingle: true
  }),
  methods: {
    makeSummary () {
      designSummary.methods.createDesignSummary()
    },
    showModelPicker () {
      this.$store.commit('model/setProperty', {property: 'modelPicker', value: true})
    }
  }
}
</script>

<template>
<div class="list">
  <md-list :md-expand-single="expandSingle">
    <md-list-item md-expand v-if="hasMaterials">
      <md-icon>color_lens</md-icon>
      <span class="md-list-item-text md-title">Materials</span>
      <md-list slot="md-expand">
        <materialList/>
      </md-list>
    </md-list-item>

    <md-list-item md-expand v-if="hasLiquid">
      <md-icon>flash_on</md-icon>
      <span class="md-list-item-text md-title">Liquifire</span>
      <md-list slot="md-expand">
        <liquidList/>
      </md-list>
    </md-list-item>

    <md-list-item md-expand v-if="hasOptions">
      <md-icon>visibility</md-icon>
      <span class="md-list-item-text md-title">Options</span>
      <md-list slot="md-expand">
        <visibilitySingleList/>
        <visibilityGroupList/>
      </md-list>
    </md-list-item>

    <md-list-item md-expand v-if="hasViews">
      <md-icon>photo_camera</md-icon>
      <span class="md-list-item-text md-title">Views</span>
      <md-list slot="md-expand">
        <viewsList/>
      </md-list>
    </md-list-item>

    <md-list-item md-expand v-if="hasEnvironmentTextures">
      <md-icon>photo_camera</md-icon>
      <span class="md-list-item-text md-title">Environment</span>
      <md-list slot="md-expand">
        <environmenttexturesList/>
      </md-list>
    </md-list-item>

    <md-list-item md-expand v-if="hasStates">
      <md-icon>layers</md-icon>
      <span class="md-list-item-text md-title">States</span>
      <md-list slot="md-expand">
        <statesList/>
      </md-list>
    </md-list-item>

    <md-divider></md-divider>

    <md-list-item @click="makeSummary">
      <md-icon>shopping_cart</md-icon>
      <span class="md-list-item-text md-title">Checkout</span>
    </md-list-item>

    <md-list-item @click="showModelPicker" v-if="hasScenes">
      <md-icon>ballot</md-icon>
      <span class="md-list-item-text md-title">Load model</span>
    </md-list-item>

  </md-list>
</div>
</template>

<style lang="scss" scoped>
  .md-title {
    font-weight: 400;
  }
</style>
